import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { useEditTargetsContext } from '@/contexts/edit-targets-context';

import { Form } from './form';
export function EditTargetsContent() {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { hiringGoal } = useEditTargetsContext();

  const onFormChange = (enabled: boolean) => {
    setIsFormDirty(enabled);
  };

  const showSpinner = (isSaving: boolean) => {
    setIsSaving(isSaving);
  };

  if (!hiringGoal) return null;

  return (
    <>
      <Form
        onFormChange={onFormChange}
        hiringGoal={hiringGoal}
        showSpinner={showSpinner}
      >
        <DialogFooter>
          <Button
            type="submit"
            disabled={!isFormDirty || isSaving}
            className="w-19"
          >
            {isSaving && <Loader2 className="animate-spin" />}
            <FormattedMessage defaultMessage="Save" />
          </Button>
        </DialogFooter>
      </Form>
    </>
  );
}
